// AccessibilityScript.tsx

import React, { useEffect } from 'react';

const AccessibilityScript: React.FC = () => {
    useEffect(() => {
        const loadScript = () => {
            if (typeof window !== 'undefined') {
                window.interdeal = {
                    sitekey: '4fc3fcae1cf1e7b5c5938c021aa7ea11',
                    Position: 'Left',
                    domains: {
                        js: 'https://cdn.equalweb.com/',
                        acc: 'https://access.equalweb.com/'
                    },
                    Menulang: 'EN',
                    btnStyle: {
                        vPosition: ['80%', '20%'],
                        scale: ['0.5', '0.5'],
                        color: {
                            main: '#1c4bb6',
                            second: '#ffffff'
                        },
                        icon: {
                            type: 13,
                            shape: 'semicircle'
                        }
                    }
                };

                // Append the accessibility.js script after window.interdeal is set
                const coreCall = document.createElement('script');
                coreCall.src = `${window.interdeal.domains.js}core/4.6.14/accessibility.js`;
                coreCall.defer = true;
                coreCall.integrity = 'sha512-DeZBWLOEHK1CkmU3vQTNSXeENfZmhTHFmn7zzhvZCPERahpp/DTouMc1ZHOu+RAo1FTKnuKEf1NQyB76z8mU1Q==';
                coreCall.crossOrigin = 'anonymous';
                coreCall.setAttribute('data-cfasync', 'true');

                document.body.appendChild(coreCall);
            }
        };

        loadScript();
    }, []);

    return null;
};

export default AccessibilityScript;
